import AccountDescriptions from "./AccountDescriptions"

export default AccountDescriptions
